import React from 'react';
import ClaveUnicaFormComponent from '../../../../../../../components/ClaveUnicaForm/redesign';
import type { PostClaveUnicaApproveResponse } from '../../../../../../../types/preloan/v2';
import type { FormSchemaV3, PostClaveUnicaResponse } from '../../../../../../../types/preloan/v3';
import type { ClaveUnicaEndpointProps } from '../../../../../../../components/ClaveUnicaForm/redesign';
import { WorkerType } from '../../../../../DependentStatusDialog';
import { inviteePlrCategory } from '../../../../ComplementInvite/analyticsPages';

type ClaveUnicaRequestProps<CUResponse> = {
    formSchema: FormSchemaV3,
    postClaveUnicaApprove: (props: ClaveUnicaEndpointProps)=> Promise<
    CUResponse>
    claveUnicaSuccess: (response: CUResponse)=> void,
    patchSiiIncome: (token: string)=> Promise<CUResponse>,
    patchDependentStatus: (workerType: WorkerType)=> Promise<void>,
    patchManualVerification: ()=> Promise<void>,
    onChangeRut: () => void,
    onLoadingChange?: (loading: boolean) => void,
}

export default function ClaveUnicaRequest<CUResponse
extends PostClaveUnicaApproveResponse|PostClaveUnicaResponse
>(props:ClaveUnicaRequestProps<CUResponse>) {
  const {
    formSchema,
    postClaveUnicaApprove,
    claveUnicaSuccess,
    patchSiiIncome,
    patchDependentStatus,
    patchManualVerification,
    onChangeRut,
    onLoadingChange,
  } = props;

  const handleFallbackUnemployed = async (): Promise<void> => {
    await patchDependentStatus('UNEMPLOYED');
  };
  return (
    <ClaveUnicaFormComponent<CUResponse>
      variant="inline"
      onChangeRut={onChangeRut}
      submitLabel="Ver mi resultado"
      customLoadingLogo={formSchema.config.styles?.minimalLogo}
      customLogo={formSchema.config.styles?.headerLogo}
      token={formSchema.PLRtoken}
      partner={{
        partnerName: formSchema.partner,
        config: formSchema.config,
        products: formSchema.products,
      }}
      pageCall={{
        category: inviteePlrCategory(formSchema.complementToken, 'PLR - ONBOARDING'),
        name: 'INGRESO CU',
      }}
      endpoint={postClaveUnicaApprove}
      idNumber={formSchema.rut}
      origin={formSchema.origin}
      callback={claveUnicaSuccess}
      fallback={patchSiiIncome}
      fallbackUnemployed={handleFallbackUnemployed}
      fallbackManualEvaluation={patchManualVerification}
      firstMessage={null}
      showDisclaimer={false}
      onLoadingChange={onLoadingChange}
    />
  );
}

ClaveUnicaRequest.defaultProps = {
  onLoadingChange: undefined,
};
